<template>
    <div>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button class="button_back" @click="goBack">
            <ion-icon name="arrow-back-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-buttons  slot="end">
          <ion-button
            @click="save('userForm')"
            :disabled="formsData.userForm.disabled"
            class="pill next-pill-button"
          >
            <span>Save</span>
          </ion-button>
        </ion-buttons>
        <ion-title>My Profile</ion-title>
      </ion-toolbar>
  
      <div class="main_wrapper ion-padding">
        <el-form
          :model="formsData?.userForm"
          :rules="formsData?.userForm.rules"
          :ref="(el) => (formsData.userForm.ref = el)"
          :label-position="'top'"
          @submit.prevent="goNext('userForm')"
          @keyup.enter="goNext('userForm')"
        >
          <div class="settings_menu">
            <div class="menu_title">
              <span>Personal Details</span>
            </div>
          </div>
          <!-- WORKING -->
          <div class="form_part">
              <el-form-item :label="formLabel" prop="firstName">
                <el-input
                  v-model="formsData.userForm.firstName.value"
                  autocomplete="off"
                  placeholder="Given Name"
                  :maxlength="20"
                  @input="fixValidation"
  
                  @keyup="
                    formsData.userForm.firstName.value = $event.target.value
                  "
  
                ></el-input>
              </el-form-item>
              <el-form-item label="Family Name" prop="lastName">
                <el-input
                  v-model="formsData.userForm.lastName.value"
                  autocomplete="off"
                  placeholder="Family Name"
                  :maxlength="20"
                  @input="fixValidation"
  
                  @keyup="formsData.userForm.lastName.value = $event.target.value"
                ></el-input>
              </el-form-item>
              <el-form-item label="Preferred Name" prop="preferredName">
                <el-input
                  v-model="formsData.userForm.preferredName.value"
                  autocomplete="off"
                  placeholder="Preferred Name"
                  :maxlength="20"
                  @input="fixValidation"
                  @keyup="
                    formsData.userForm.preferredName.value = $event.target.value
                  "
                ></el-input>
              </el-form-item>
            <el-form-item label="Find Your Address" prop="address">
              <div class="el-input el-input--prefix">
                <vue-google-autocomplete
                  id="map"
                  classname="el-input__inner"
                  :ref="(el) => (formsData.userForm.address.ref = el)"
                  v-model="formsData.userForm.address.value.text"
                  placeholder="Find your address"
                  @placechanged="setAddressData"
                  @input="fixValidation"
                  @keyup="setAddress"
                  :country="countryArray"
                >
                </vue-google-autocomplete>
                <span class="el-input__prefix"
                  ><i class="el-input__icon el-icon-search"></i
                ></span>
              </div>
            </el-form-item>
          </div>
          <!-- !!!!!  -->
          <!-- WORKING -->
          <div class="form_part">
            <el-form-item
              label="Phone Number"
              prop="mobileNumber"
              :required="true"
              class="collapsing-dropdown-scroll-off"
            >
              <div class="el-input">
                <vue-tel-input
                  class="el-input__inner"
                  :value="formsData.userForm.mobileNumber.valueFormatted"
                  v-model="formsData.userForm.mobileNumber.value"
                  @input="onPhoneInput"
                  :preferredCountries="[$filters.vueTelInput()]" :autoDefaultCountry="false"
                  v-bind="{ mode: 'international' }"
                ></vue-tel-input>
              </div>
            </el-form-item>
            <el-form-item label="Email" prop="email" :required="true">
              <el-input
                type="email"
                v-model="formsData.userForm.email.value"
                placeholder="email@gmail.com"
                @input="fixValidation"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form_part">
            <div class="settings_menu" id="modify_AHPRA">
              <div class="menu_title">AHPRA Verification</div>
            </div>
            <el-form-item
              label="AHPRA Registration number"
              prop="ahpraNumber"
              :required="true"
              style="margin-top: 1rem"
            >
              <input
                class="el-input__inner"
                :ref="(el) => (formsData.userForm.ahpraNumber.ref = el)"
                :value="formsData.userForm.ahpraNumber.value"
                :placeholder="'AAA 000000000'"
                v-imask="formsData.userForm.ahpraNumber.mask"
                @accept="onFormMaskAccept($event, 'userForm', 'ahpraNumber')"
                @blur="checkFormValidation('userForm', true, 'ahpraNumber')"
              />
            </el-form-item>
            <el-form-item
              label="Expiry Date"
              prop="ahpraExpiryDate"
              :required="true"
            >
              <el-date-picker
                popper-class="datepicker_popper"
                v-model="formsData.userForm.ahpraExpiryDate.valueFormatted"
                type="date"
                placeholder="DD/MM/YYYY"
                format="DD/MM/YYYY"
                @change="dateConvert"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </template>
  
  <script>
  import {
    onMounted,
    inject,
    defineAsyncComponent,
    nextTick,
    computed
  } from "vue";
  
  import { addIcons } from "ionicons";
  import { arrowBackOutline } from "ionicons/icons";
  // import moment from "moment";
  
  addIcons({
    "arrow-back-outline": arrowBackOutline,
  });
  import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
  } from "@ionic/vue";
  
  import { useStore } from "vuex";
  import {
    useRouter,
    onBeforeRouteLeave,
  } from "vue-router";
  import formHooks from "@/hooks/form/form";
  import formValidate from "@/hooks/form/validate/validate";
  
  import addressText from "@/helpers/address/address.js";
  
  import { VueGoogleAutocomplete } from "@/components/components";
  
  import { ElMessageBox } from "@/components/Vendor/Element";

  import formMasks from "@/hooks/form/mask/mask";

  import IMaskDirective from "@/directives/vue-imask/directive";

  import IMask from "imask/esm/imask";
  
  import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';

  const VueTelInput = defineAsyncComponent(() =>
    import("@/components/Vendor/vue-tel-input/components/vue-tel-input.vue")
  );
  
  export default {
    components: {
      IonToolbar,
      IonButton,
      IonButtons,
      IonIcon,
      IonTitle,
  
      VueGoogleAutocomplete,
  
      VueTelInput,
    },
    directives: {
    imask: IMaskDirective,
  },
    setup() {
     
      const $store = useStore();
      const $router = useRouter();
      const setPageClassGlobal = inject(["setPageClassGlobal"]);
      const googleMaps = inject(["googleMaps"]);
      const $moment = inject(["$moment"]);
      const userData = $store.getters.GET_USER_DATA;
      const userRole = userData.role;
      const email = userData.email;
      const isAustralia = isAustraliaRegion();
      const ahpra = userData.ahpra ? userData.ahpra : {};
      const countryArray = computed(() => {
            const region = process.env.VUE_APP_REGION;
            if (region === 'US') return ['us'];
            if (region === 'AU') return ['au'];
            return []; // Default or empty if region is not recognized
        });
      
      const ahpraExpiryDateValue = ahpra.date
      ? $moment(ahpra.date, "YYYY-MM-DD").format("YYYY-MM-DD")
      : new Date(new Date().setFullYear(new Date().getFullYear()));
     
      const formsDataArray = {
        userForm: {
            firstName: {
            value: userData?.firstName || "",
            resetValue: true,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "firstName",
                    callback,
                    setFormValidation
                  );
                },
              },
            ],
          },
          lastName: {
            value: userData?.lastName || "",
            resetValue: true,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "lastName",
                    callback,
                    setFormValidation
                  );
                },
              },
            ],
          },
          preferredName: {
            value: userData?.preferredName || "",
            resetValue: true,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "preferredName",
                    callback,
                    setFormValidation
                  );
                },
              },
            ],
          },
          address: {
            value: {
              text: addressText(userData.address ? userData.address : ''),
              temp: addressText(userData.address ? userData.address : ''),
            },
            resetValue: true,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "address",
                    callback,
                    setFormValidation
                  );
                },
              },
            ],
          },
  
          mobileNumber: {
            ref: {},
            value: userData.mobileNumber ? userData.mobileNumber : "",
            valueFormatted: userData.mobileNumber ? userData.mobileNumber : "",
            resetValue: true,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "mobileNumber",
                    callback,
                    setFormValidation
                  );
                },
              },
            ],
            errors: null,
          },
          email: {
            value: email ? email : "",
            resetValue: true,
            validators: [
              {
                validator: (rule, formField, callback) => {
                  formValidate.validate(
                    rule,
                    formField,
                    "email",
                    callback,
                    setFormValidation
                  );
                },
                trigger: ["blur", "enter"],
              },
            ],
          },
          ahpraNumber: {
          value: ahpra.number
            ? IMask.createMask(formMasks.ahpraNumber).resolve(ahpra.number)
            : "",
          mask: formMasks.ahpraNumber,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "ahpraIe",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },

        ahpraExpiryDate: {
          ref: null,
          value: ahpra.date ? ahpraExpiryDateValue : "",
          valueFormatted: ahpra.date ? ahpraExpiryDateValue : "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  {
                    rule: "ahpraExpiryDateIe",
                  },
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        },
      };
  
  
  
      const onPhoneInput = (value, phoneObject) => {
        if (!value.target) {
          formsData.userForm.mobileNumber.ref.phoneObject = phoneObject;
        }
        formsData.userForm.mobileNumber.valueFormatted = value.target
          ? value.target.value
          : value;
        formsData.userForm.mobileNumber.value =
          formsData.userForm.mobileNumber.ref.phoneObject.number || null;
  
        checkFormValidation("userForm", false, "mobileNumber");
        checkFormValidation("userForm", true);
  
      };
  
      // Define a computed property to determine the label dynamically
      const formLabel = 'Given Name';
  
      const setAddress = () => {
        if (
          formsData.userForm.address.value.text !=
          formsData.userForm.address.value.temp
        ) {
          formsData.userForm.address.value.text = null;
        }
        checkFormValidation("userForm", true, "address");
        checkFormValidation("userForm", true);
  
      };

      const fixValidation = () => {
                    // Forcing to check form validation as continue button was not working
                    checkFormValidation('userForm', true)
                }
  
      const setAddressData = async (addressData, placeResultData) => {
        try {
          formsData.userForm.address.value.lat = addressData.latitude.toString();
          formsData.userForm.address.value.lng = addressData.longitude.toString();
          formsData.userForm.address.value.subpremise = (addressData.subpremise ? addressData.subpremise : "") 
          formsData.userForm.address.value.street =
            (formsData.userForm.address.value.subpremise
              ? formsData.userForm.address.value.subpremise + "/"
              : "") +
            (addressData.street_number ? addressData.street_number + " " : "") +
            addressData.route;
          
          formsData.userForm.address.value.state =
            addressData.administrative_area_level_1
              ? addressData.administrative_area_level_1
              : "";
          formsData.userForm.address.value.suburb = addressData.locality
            ? addressData.locality
            : "";
          formsData.userForm.address.value.country = addressData.country
            ? addressData.country
            : "";
          formsData.userForm.address.value.postcode = addressData.postal_code
            ? addressData.postal_code
            : "";
  
          console.log("placeResultData", placeResultData.formatted_address);
          formsData.userForm.address.value.text =
            placeResultData.formatted_address;
          formsData.userForm.address.value.temp =
            placeResultData.formatted_address;
          formsData.userForm.address.ref.update(
            formsData.userForm.address.value.text
          );
          const timezone = await googleMaps.getTimeZone(
            formsData.userForm.address.value.lat +
              "," +
              formsData.userForm.address.value.lng
          );
          formsData.userForm.address.value.timezone = timezone.timeZoneId;
        } catch (error) {
          console.log(error);
        }
        checkFormValidation("userForm", true);
      };
  
      const goBack = () => {
        $router.push({
          name: "profile",
        });
      };
  
      const getFormData = (formName) => {
        const result = Object.fromEntries(
          Object.entries(formsData[formName])
            .map(([k, v]) => [k, v?.value])
            .filter(([k, v]) => v !== undefined) // eslint-disable-line no-unused-vars
        );
        if (result.ahpraNumber) {
        result.ahpraNumber = result.ahpraNumber.replaceAll(" ", "");
        result.ahpraNumber = result.ahpraNumber.replaceAll("_", "");
      }
        return result;
      };
   
  
      const save = (formName) => {
        console.log('formName',formName)
        formsRefs[formName].value.validate((valid) => {
          if (valid) {
            return (async () => {
              try {
                
                if (
                  (formsData[formName].firstName &&
                    formsData[formName].firstName.fieldChanged) ||
                  (formsData[formName].lastName &&
                    formsData[formName].lastName.fieldChanged)
                ) {
                  await ElMessageBox.confirm(
                    "Are you sure you want to change this?",
                    {
                      distinguishCancelAndClose: true,
                      showConfirmButton: !formsData[formName].disabled,
                      confirmButtonText: "Save Changes",
                      cancelButtonText: "Cancel",
                      confirmButtonClass: "el-button--green",
                      cancelButtonClass: "el-button--grey",
                      showClose: formsData[formName].disabled,
                    }
                  );
                  $store.dispatch("IDENTIFY_USER", {
                    name: formsData[formName].firstName.value,
                  });
                  console.log('IDENTIFY SUCCESFULLY')
  
                }
                const data = getFormData(formName);
                const mobileNumber = data.mobileNumber;
                const email = data.email;
                delete data.mobileNumber;
                delete data.email;
  
                let requests = [];
                requests.push($store.dispatch("SAVE_USER_DATA", data));
                let mobileNumberChanged = false;
                let emailChanged = false;
                console.log('FORM DATA:', formsData[formName])
                if (
                  formsData[formName].mobileNumber &&
                  formsData[formName].mobileNumber.fieldChanged
                ) {
                  mobileNumberChanged = true;
                  requests.push(
                    $store.dispatch("UPDATE_USER_PHONE", {
                      phone: mobileNumber,
                    })
                  );
                }
  
                if (
                  formsData[formName].email &&
                  formsData[formName].email.fieldChanged
                ) {
                  emailChanged = true;
                  requests.push($store.dispatch("IDENTIFY_USER", { email }));
                  requests.push(
                    $store.dispatch("UPDATE_USER_EMAIL", {
                      email: email,
                    })
                  );
                }
  
                await Promise.all(requests);
  
                if (mobileNumberChanged) {
                  $store.dispatch("setVerifyPageData", {
                    mobileNumber: mobileNumber,
                  });
                }
  
                if (emailChanged) {
                  $store.dispatch("setVerifyPageData", {
                    email: email,
                  });
                }
  
                copyFormResetValue("userForm", true);
                goBack();
              } catch (errors) {
                $store.dispatch("clearVerifyPageData", {
                  mobileNumber: null,
                  email: null,
                });
                for (let key in errors) {
                  setFieldError(formName, key, errors[key]);
                  // }
                  // setFieldError('userForm', 'password', error.message);
                }
                checkFormValidation(formName, true);
                nextTick(() => {
                  setFormValidation(formName, "mobileNumber", true);
                });
              }
            })();
          } else {
            setFormValidation(formName, false, false);
            console.log("error submit!!");
            return false;
          }
        });
      };
  
      onBeforeRouteLeave((to, from, next) => {
        (async () => {
          try {
            let leave = await checkFormChanged("userForm");
            if (leave == "save") {
              await save("userForm");
            } else if (!leave) {
              next(false);
            } else {
              next();
            }
          } catch (error) {
            next(false);
            console.log(error);
          }
        })();
      });
  
      onMounted(() => {
     
        setPageClassGlobal("global_basic_profile_edit_ie_page");
        setFormRefs();
       
        formsData.userForm.address.ref.update(
          formsData.userForm.address.value.text
        );
  

        checkFormValidation("userForm", true);
  
      });
  
      const {
        ["onFormMaskAccept"]: onFormMaskAccept,
        checkFormValidation,
        setFormValidation,
        copyFormResetValue,
        checkFormChanged,
        setFieldError,
        getFormValues, // eslint-disable-line no-unused-vars
        setFormRefs,
        formsData,
        formsRefs,
      } = formHooks(formsDataArray);
  
      return {
        formsData,
        onFormMaskAccept,
        checkFormValidation,
        goBack,
        save,
        userData,
        userRole,
        setAddressData,
        setAddress,
        onPhoneInput,
        formLabel,
        fixValidation,
        countryArray,
        isAustralia,
        ahpra,
        ahpraExpiryDateValue
      };
    },
  };
  </script>